import React from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication, EventType, InteractionType } from '@azure/msal-browser';
import { BrowserRouter as Router } from 'react-router-dom';
import { msalConfig } from './common/constants/authConfig.js';
import App from './App';
import './index.css';

export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Router>
    <App instance={msalInstance} />
  </Router>
);
